import axios from "axios";

import endpoints from "src/core/endpoints";

class LoggerService {
    public debug(name: string, data: unknown) {
        return axios.post(endpoints.logger, {
            name,
            data,
        });
    }
}

export const loggerService = new LoggerService();
